import React from 'react';
import {useIntl} from 'react-intl';
import cn from 'classnames';

import {getAssetUrl} from 'coreUtils/adapters/sdk';

import Image from 'brandComponents/Image';
import {useSocialLoginContext} from 'brandComponents/SocialLogin/SocialLoginContext';

import SocialLoginButton from '../SocialLoginButton';

import {ISocialLoginLineProps} from './ISocialLoginLine';
import messages from './messages';

import styles from './SocialLoginLine.module.scss';

const SocialLoginLine = ({classNames}: ISocialLoginLineProps) => {
	const intl = useIntl();
	const {onLogin} = useSocialLoginContext();
	const lineImg = getAssetUrl('static/img/social_line.png');

	return (
		<SocialLoginButton
			classNames={cn(styles['social-login__line'], classNames)}
			idp="Line"
			handleSocialLoginBtn={onLogin}
			isRedirectLogin
		>
			<div className={styles['social-login__line__image-wrapper']}>
				<Image src={lineImg} alt="Line Pay logo" className={styles['social-login__line__image']} showSkeleton={false} />
			</div>
			<span>{intl.formatMessage(messages.login)}</span>
		</SocialLoginButton>
	);
};

export default SocialLoginLine;
